import React from "react";
import moment from "moment";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Countdown, { CountdownRenderProps } from "react-countdown";
import { useTranslation } from "react-i18next";

import Info from "assets/images/svg/info_dark.svg";
import Done from "assets/images/svg/done_white.svg";

import { useModal } from "hooks";
import ChangeNumberComponent from "pages/registration/components/change-number.component";
import { Form, InputField } from "components/form";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";
import { client } from "helpers/client";
import { toast } from "react-toastify";

export const TempNumberValidatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isAllowedToChangeNumber, setIsAllowedToChangeNumber] = React.useState(false);
  const [showChangeNumberDialog, openChangeNumberDialog, closeChangeNumberDialog] = useModal(false);
  const { preregisterData, setPreregisterData, isStillBlocked, isStillValid } = usePreregisterData();
// trying new 
  async function handlePhoneVerification(data: any) {
    const verifyMobileDto = {
      mobileId: preregisterData?.mobileId,
      code: data.code,
      isPrimaryMobile: true,
      fromLandingPage: true
    };
    const { response, error } = await client<PreregisterDto>("/auth/verifyMobile", { data: verifyMobileDto });
    if (error) return;
    if (response) {
      toast.success("Registration completed successfully");
      navigate("/login");
      sessionStorage.removeItem("preregister-data");
    }
  }

  async function handleSendAgain() {
    if (isStillBlocked) return navigate("/info/blocked-mobile");
    const { response } = await client<PreregisterDto>(`/auth/resendMobileCode/${preregisterData?.mobileId}`, { method: "POST" });
    response && setPreregisterData(response);
  }

  if (!preregisterData) return <Navigate to="/temp-register" />;
  if (isStillBlocked && !isStillValid) return <Navigate to="/info/blocked-mobile" />;

  return (
    <div className="registration numberValidate">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="title">
                {t("numberValidate:title") as string}
                <span>{t("numberValidate:number") as string}</span>
              </h1>
              <div className="steps">
                <span className="done">
                  <img src={Done} alt="done" />
                </span>

                <span className="line" />
                <span className="active">2</span>
                <span className="">3</span>
              </div>
            </div>
            <Form onSubmit={handlePhoneVerification} className="col-lg-6">
              <InputField
                id="code"
                label={t("numberValidate:verifyCode")}
                rules={{
                  required: "errors:required",
                  minLength: {
                    value: 5,
                    message: "errors:invalidFormat"
                  },
                  maxLength: {
                    value: 5,
                    message: "errors:invalidFormat"
                  }
                }}
              />
              <div className="info">
                <img src={Info} alt="info" />
                <p>{t("numberValidate:important") as string}</p>
              </div>
              <button type="button" disabled={!isAllowedToChangeNumber} onClick={openChangeNumberDialog} className="change">
                {t("numberValidate:change") as string}
              </button>
              <div className="row">
                <div className="col-md-6">
                  <button className="btn-blue">{t("numberValidate:verify") as string}</button>
                </div>
                <div className="col-md-6">
                  <div className="timer">
                    {/*@ts-ignore*/}
                    <Countdown
                      onComplete={() => setIsAllowedToChangeNumber(true)}
                      onStart={(p) => setIsAllowedToChangeNumber(p.completed)}
                      renderer={(p) => <SendButton {...p} onClick={handleSendAgain} />}
                      key={moment(preregisterData.expiryDate).toISOString()}
                      date={moment(preregisterData.expiryDate).add(1, "seconds").toDate() ?? 0}
                    />
                  </div>
                </div>
              </div>
              <div className="trouble">
                <p>
                  {t("numberValidate:trouble") as string}
                  <Link to="/contact-us">{t("numberValidate:support") as string}</Link>
                  {t("numberValidate:contact") as string}
                </p>
              </div>
            </Form>
            <ChangeNumberComponent
              show={showChangeNumberDialog}
              onHide={closeChangeNumberDialog}
              onChangeNumber={(data) => {
                setPreregisterData(data);
                closeChangeNumberDialog();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

interface SendButtonProps extends CountdownRenderProps {
  onClick: () => void;
}
const SendButton = ({ onClick, formatted, completed }: SendButtonProps) => {
  const { t } = useTranslation();
  return completed ? (
    <button type="button" className="btn fw-bold" onClick={onClick}>
      {t("security:send-again") as string}
    </button>
  ) : (
    <p>
      {formatted.hours}:{formatted.minutes}:{formatted.seconds}
    </p>
  );
};

export default TempNumberValidatePage;
